__turbopack_context__.v({
  "callIcon": "footer-module-scss-module__sYHMDa__callIcon",
  "contact": "footer-module-scss-module__sYHMDa__contact",
  "contactBox": "footer-module-scss-module__sYHMDa__contactBox",
  "contactSponsored": "footer-module-scss-module__sYHMDa__contactSponsored",
  "copyright": "footer-module-scss-module__sYHMDa__copyright",
  "emailError": "footer-module-scss-module__sYHMDa__emailError",
  "footerBottomSection": "footer-module-scss-module__sYHMDa__footerBottomSection",
  "heading": "footer-module-scss-module__sYHMDa__heading",
  "logo": "footer-module-scss-module__sYHMDa__logo",
  "message": "footer-module-scss-module__sYHMDa__message",
  "newsletterBox": "footer-module-scss-module__sYHMDa__newsletterBox",
  "newsletterButton": "footer-module-scss-module__sYHMDa__newsletterButton",
  "newsletterInput": "footer-module-scss-module__sYHMDa__newsletterInput",
  "root": "footer-module-scss-module__sYHMDa__root",
  "socialMedia": "footer-module-scss-module__sYHMDa__socialMedia",
  "subHeading": "footer-module-scss-module__sYHMDa__subHeading",
});
